export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const API_ENDPOINTS = {
  VERSION_CHECK: `${BASE_URL}/api/v1/master-service/version-check`,
  APP_CONFIG: (customUrlPath) =>
    `${BASE_URL}/api/v1/master-service/products/${customUrlPath}/config?include_config=true`,
  CUSTOMER_EXISTS: `${BASE_URL}/api/v1/customer-service/auth/customer-exists`,
  REGISTER_INITIATE: `${BASE_URL}/api/v1/customer-service/register/initiate`,
  LOGIN_INITIATE: `${BASE_URL}/api/v1/customer-service/login/initiate`,
  REGISTER_VERIFY_OTP: `${BASE_URL}/api/v1/customer-service/register`,
  LOGIN_VERIFY_OTP: `${BASE_URL}/api/v1/customer-service/login`,
  PROFILE_DETAILS: `${BASE_URL}/api/v1/customer-service/auth/profile`,
  REGISTER_SET_PIN: `${BASE_URL}/api/v1/customer-service/register`,
  LOGIN_SET_PIN: `${BASE_URL}/api/v1/customer-service/login`,
  FORGOT_PASSWORD_INITIATE: `${BASE_URL}/api/v1/customer-service/forgot-password/initiate`,
  FORGOT_PASSWORD_VERIFY_OTP: `${BASE_URL}/api/v1/customer-service/forgot-password`,
  FORGOT_PASSWORD_SET_PIN: `${BASE_URL}/api/v1/customer-service/forgot-password`,
  REFRESH_TOKEN: `${BASE_URL}/api/v1/customer-service/auth/refresh-token`,
  LOGOUT: `${BASE_URL}/api/v1/customer-service/auth/logout`,
  ME: `${BASE_URL}/api/v1/customer-service/auth/me`,
  CHANGE_PASSWORD_INITIATE: `${BASE_URL}/api/v1/customer-service/change-password/initiate`,
  CHANGE_PASSWORD_VERIFY_OTP: `${BASE_URL}/api/v1/customer-service/change-password`,
  CHANGE_PASSWORD_SET_PIN: `${BASE_URL}/api/v1/customer-service/change-password`,
  COMPLETE_FINANCE: ({ requestId, taskId }) =>
    `${BASE_URL}/api/v1/workflow-service/requests/${requestId}/tasks/${taskId}/complete`,
  MERCHANT_ONBOARDING_STATUS: `${BASE_URL}/api/v1/workflow-service/requests/merchant-onboarding-status`,
  FINANCE_APPLICATION_STATUS: `${BASE_URL}/api/v1/workflow-service/requests/finance-application-status`,
  FINANCE_NEXT_TASK: (requestId) =>
    `${BASE_URL}/api/v1/workflow-service/requests/${requestId}/next-task`,
  FINANCE_APPLICATIONS: (id) =>
    `${BASE_URL}/api/v1/finance-service/finance-applications/${id}`,
  AUTH_BACK_SESSION: `${BASE_URL}/api/v1/customer-service/auth/sessions/back`,
  FINANCE_BACK_TASK: ({ requestId, taskId }) =>
    `/api/v1/workflow-service/requests/${requestId}/tasks/${taskId}/navigate-to-back`,
  CR_LOGIN: `${BASE_URL}/api/v1/customer-service/cr-login/initiate`,
  CUSTOMER_CONSENT: `${BASE_URL}/api/v1/customer-service/cr-login`,
  NAFATH_VERIFICATION: `${BASE_URL}/api/v1/customer-service/cr-login/auth_status`,
  CURRENT_APPLICARION_WORKFLOW: `${BASE_URL}/api/v1/workflow-service/requests/current-application`,
  LOGIN: `${BASE_URL}/api/v1/customer-service/auth/register-url`,
  LOGIN_CALL_BACK: `${BASE_URL}/api/v1/customer-service/auth/login-callback`,
  PARTNER_LOGIN: `${BASE_URL}/api/v1/customer-service/auth/partner-login`,
  UPLOAD_URL: (applicationId) =>
    `${BASE_URL}/api/v1/finance-service/applications/${applicationId}/documents`,
  UPLOAD_DOCUMENT_COMPLETION: (params) =>
    `${BASE_URL}/api/v1/finance-service/applications/${params?.applicationId}/documents/${params?.documentId}/complete`,
  CAMPAIGN_SCREEN: (campaignSlug) =>
    `${BASE_URL}/api/v1/engine-service/pages/${campaignSlug}`,
  AUTH_CONNECT: `${BASE_URL}/api/v1/integration-service/connect/auth`,
  SHORT_LINK_VERIFY: (code) =>
    `/api/v1/master-service/short-links/${code}/verify`,
  GET_PROVIDERS: (connect_base_url) => `${connect_base_url}/v1/providers`,
  CREATE_INTENT: (connect_base_url) =>
    `${connect_base_url}/accountInformation/v1/intent`,
  VERIFY_OTP: `${BASE_URL}/api/v1/customer-service/cr-login/verify-otp`,
  GET_DOCUMENT_LIST: (applicationId) =>
    `${BASE_URL}/api/v1/finance-service/applications/${applicationId}/documents`,
  DELETE_DOCUMENT: ({ applicationId, documentId }) =>
    `${BASE_URL}/api/v1/finance-service/applications/${applicationId}/documents/${documentId}`,
  DISTRIBUTOR_LOGIN: `${BASE_URL}/api/v1/customer-service/auth/distributor-login`,
  DISTRIBUTOR_VERIFY_OTP: `${BASE_URL}/api/v1/customer-service/auth/distributor/otp-verify`,
};

export const PLATFORM = {
  IOS: "ios",
  ANDROID: "android",
};

export const ROUTES = {
  REGISTER: "register",
  COMPANY_DETAILS: "company-details",
  NAFATH_VERIFICATION: "nafath-verification",
  WATHQ_VERIFICATION: "wathq-verification",
  LINK_BANK: "link-bank",
  VERIFY_OTP: "verify-otp",
  ALM_VERIFICATION: "alm-verification",
  VERIFY_PIN: "verify-pin",
  ONBOARDING_SPLASH: "onboarding-splash",
  ONBOARDING: "onboarding",
  APPLY_DASHBOARD: "apply-dashboard",
  SETTINGS: "settings",
  PROFILE_DETAILS: "profile-details",
  LANGUAGE: "language",
  CONTACT_US: "contact-us",
  VERIFY_BANK_DETAIL: "verify-bank-detail",
  ELIGIBILITY: "eligibility",
  TERMS_AND_CONDITIONS: "terms-and-conditions",
  FAQ: "faq",
  FINANCE_DETAIL: "finance-detail",
  STATUS_DASHBOARD: "status-dashboard",
  PAYMENTS: "payments",
  COMPLETED_PAYMENTS: "completed-payments",
  MERCHANT_DASHBOARD: "merchant-dashboard",
  MERCHANT_ONBOARDING: "merchant-onboarding",
  FINANCE_ELIGIBILITY: "finance-eligibility",
  MERCHANT_SUPPORT: "merchant-support",
  LINK_ACCOUNT_OTP: "link-account-otp",
  LINK_ACCOUNT_REGISTER: "link-account-register",
  FINANCING_DETAILS: "financing-details",
  LOAN_DETAILS: "loan-details",
  ACCEPT_TERMS_AND_CONDITION: "accept-terms-and-condition",
  CR_REGISTER: "cr-register",
  LOGIN: "login",
  PARTNER_JOURNEY: "partner-journey",
  CHECK_ELIGIBILITY: "check-eligibility",
  SELECT_FINANCE_PARTNER: "select-finance-partner",
  PRIVACY_POLICY: "privacy-policy",
  REPAYMENT_SCHEDULE: "repayment-schedule",
};

export const NEXT_AUTH_FACTOR = {
  VERIFY_OTP: "VERIFY_OTP",
  VERIFY_PIN: "VERIFY_PIN",
  SET_PIN: "SET_PIN",
  CUSTOMER_CONSENT: "CUSTOMER_CONSENT",
  NAFATH_VERIFICATION: "NAFATH_VERIFICATION",
  CR_INFORMATION: "CR_INFORMATION",
};

export const HEADER = {
  REQUEST_TENANT: "x-tenant-id",
  ACCEEPT_LAGUAGE: "accept-language",
  DEVICE_ID: "x-device-id",
  FLOW_ID: "x-flow-id",
  AUTHORIZATION: "authorization",
  REFRESH_TOKEN: "refresh",
  CHANNEL_ID: "x-channel-id",
  NAFATH_CODE: "random",
  USER_ID: "x-user-id",
  PRODUCT_SLUG: "x-product-slug",
  APPLICATION_ID: "x-application-id",
  APP_VERSION: "x-client-app-version",
  CONNECT_AUTH_API_KEY: "x-api-key",
};

export const CAMPAIGN = {
  HOME: "HOME",
};

export const ACCOUNT_STATE = {
  CREATE: "create",
  CONFIRM: "confirm",
  LOGIN: "login",
  FORGOT: "forgot",
  CHANGE_PASSWORD: "changePassword",
};

export const STORAGE_KEYS = {
  ONBOARDING_COMPLETED: "ONBOARDING_COMPLETED",
  DEFAULT_LANGUAGE: "DEFAULT_LANGUAGE",
  PREFERED_LANGUAGE: "PREFERED_LANGUAGE",
  THEME_MODE: "THEME_MODE",
  LOADER: "LOADER",
  CUSTOM_PATH: "CUSTOM_PATH",
  CAN_RUN_CAMPAIGN: "CAN_RUN_CAMPAIGN",
  PROVIDER_DATA: "PROVIDER_DATA",
  PARTNER_TENANT_ID: "PARTNER_TENANT_ID",
  PARTNER_TENANT_SLUG: "PARTNER_TENANT_SLUG",
  PARTNER_TENANT_NAME: "PARTNER_TENANT_NAME",
  PRE_LOGIN_COMPLETED: "PRE_LOGIN_COMPLETED",
  AUTH_CONNECT: "AUTH_CONNECT",
  PRODUCT_ID: "PRODUCT_ID",
  LOCAL_FORM_STATE: "LOCAL_FORM_STATE",
};

export const DIRECTION = {
  LTR: "ltr",
  RTL: "rtl",
};

export const TEMPLATE = {
  HEADER: "header",
  BODY: "body",
  FOOTER: "footer",
};

export const HEADER_TYPES = {
  STEPPER: "stepper",
  DASHBOARD_HEADER: "dashboard_header",
  DEFAULT_HEADER: "default_header",
  ONBOARDING_HEADER: "onboarding_header",
};

export const BODY_TYPES = {
  HEADING: "heading",
  FORM: "form",
  IMAGE: "image",
  INFO_CARD: "info_card",
  CONTENT_HEADING: "content_heading",
  STEP_CARD: "step_card",
  QUEUE_CARD: "queue_card",
  DETAIL_CARD: "detail_card",
  PROGRESS_CIRCLE_CHART: "progress_circle_chart",
  TAB_BAR: "tab_bar",
  ELIGIBILITY_CARDS: "eligibility_cards",
  VERIFY_STATUS: "verify_status",
  OTP_INPUT: "otp_input",
  PHONE_NUMBER_INPUT: "phone_number_input",
  SLIDER_CARD: "slider_card",
  LOAN_PROGRESS_CARD: "loan_progress_card",
  LOAN_DETAILS_CARD: "loan_details_card",
  MEAT_BALLS_LOADER: "meat_balls_loader",
  ONBOARDING_CARD: "onboarding_card",
  LOAN_DISBURSEMENT_CARD: "loan_disbursement_card",
  BANK_SELECT_CARD: "bank_select_card",
  CUSTOM_CONNECT_CARD: "custom_connect_card",
  CUSTOM_CONTENT_CARD: "content_card",
  BULLET_CARD: "bullet_card",
  UPLOAD_CARD: "upload_card",
  REQUEST_ID_CARD: "request_id_card",
  POWERED_BY: "powered_by",
  UPLOAD_SUCCESS_CARD: "document_uploaded_card",
  STATUS_INFO_CARD: "status_info_card",
  CONNECT_BANK_CARD: "connect_bank_card",
  COLLAPSIBLE_INFO: "collapsible_info",
  DATA_LABEL_CARD: "data_label_card",
  PING_PONG_ICONS: "ping_pong_icons",
  REQUIRED_DOCUMENTS_CARD: "required_documents_card",
  FILE_UPLOAD_CARD: "file_upload_card",
  PARTNER_LIST_CARD: "partner_list_card",
  CURRENT_LINKED_BANK_CARD: "current_linked_bank_card",
  SELECTED_BANK_BADGE: "selected_bank_bagde",
  PAYMENT_SCHEDULE_CARD: "payment_schedule_card",
  DOCUMENT_UPLOAD_CARD: "document_upload_card",
  EXCLAMATION_ERROR_IMAGE: "exclamation_error_image",
  STEPPER_SECTION: "stepper_section",
  SELECTABLE_ITEM_CARD: "selectable_item_card",
  INFO_KEY_VALUE_CARD: "info_key_value_card",
  PAYMENT_METHOD_CARD: "payment_method_card",
  REQUIRED_LIST_DOCUMENT_CARD: "required_list_document_card",
  DATE_PICKER_INPUT: "date_picker_input",
  NOTICE_CARD: "notice_card",
  DOWNLOAD_DOCUMENT_CARD: "download_document_card",
  DOCUMENT_GROUP_UPLOAD_CARD: "document_group_upload_card",
  HEADING_SKELETON: "heading_skeleton",
  DETAIL_CARD_SKELETON: "detail_card_skeleton",
  NOTICE_CARD_SKELETON: "notice_card_skeleton",
  BUTTON_SKELETON: "button_skeleton",
  HOW_IT_WORKS_CARDS: "how_it_works_cards",
  AVAILABLE_ASSETS_CARD: "available_assets_card",
  RADIO_GROUP: "radio_group_card",
  EDIT_OPTION_CARD: "edit_option_card",
  INITIAL_FORM_STATE: "initial_form_state",
};

export const FOOTER_TYPES = {
  DEFAULT_BUTTON: "default_button",
  MEAT_BALLS_LOADER: "meat_balls_loader",
  RESEND_OTP: "resend_otp",
  ACCEPT_OUR_TC: "accept_our_tc",
  ICON_TEXT: "icon_text",
  CHECK_BOX_PERMISSION: "check_box_permission",
  POWERED_BY: "powered_by",
  PAGINATION_DOT: "pagination_dot",
  SKIP_BUTTON: "skip_button",
  LINK_TEXT: "link_text",
  ACCEPT_OUR_CONSENT: "accept_our_consent",
};

export const ENDPOINT_HEADERS = {
  [API_ENDPOINTS.APP_CONFIG]: [HEADER.CHANNEL_ID],
  [API_ENDPOINTS.VERSION_CHECK]: [HEADER.REQUEST_TENANT],
  [API_ENDPOINTS.CUSTOMER_EXISTS]: [HEADER.REQUEST_TENANT],
  [API_ENDPOINTS.REGISTER_INITIATE]: [HEADER.REQUEST_TENANT, HEADER.DEVICE_ID],
  [API_ENDPOINTS.REGISTER_VERIFY_OTP]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.REGISTER_SET_PIN]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.CR_LOGIN]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.CUSTOMER_CONSENT]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.NAFATH_VERIFICATION]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.LOGIN_INITIATE]: [HEADER.REQUEST_TENANT, HEADER.DEVICE_ID],
  [API_ENDPOINTS.LOGIN_VERIFY_OTP]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.LOGIN_SET_PIN]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.FORGOT_PASSWORD_INITIATE]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
  ],
  [API_ENDPOINTS.FORGOT_PASSWORD_VERIFY_OTP]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.FORGOT_PASSWORD_SET_PIN]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.PROFILE_DETAILS]: [
    HEADER.AUTHORIZATION,
    HEADER.REQUEST_TENANT,
  ],
  [API_ENDPOINTS.REFRESH_TOKEN]: [HEADER.REQUEST_TENANT, HEADER.REFRESH_TOKEN],
  [API_ENDPOINTS.LOGOUT]: [
    HEADER.AUTHORIZATION,
    HEADER.REFRESH_TOKEN,
    HEADER.REQUEST_TENANT,
  ],
  [API_ENDPOINTS.ME]: [HEADER.AUTHORIZATION, HEADER.REQUEST_TENANT],
  [API_ENDPOINTS.CHANGE_PASSWORD_INITIATE]: [
    HEADER.AUTHORIZATION,
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
  ],
  [API_ENDPOINTS.CHANGE_PASSWORD_VERIFY_OTP]: [
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.CHANGE_PASSWORD_SET_PIN]: [
    HEADER.AUTHORIZATION,
    HEADER.REQUEST_TENANT,
    HEADER.DEVICE_ID,
    HEADER.FLOW_ID,
  ],
  [API_ENDPOINTS.MERCHANT_ONBOARDING_STATUS]: [
    HEADER.AUTHORIZATION,
    HEADER.REQUEST_TENANT,
  ],
  [API_ENDPOINTS.FINANCE_APPLICATION_STATUS]: [
    HEADER.AUTHORIZATION,
    HEADER.REQUEST_TENANT,
  ],
  [API_ENDPOINTS.FINANCE_NEXT_TASK]: [
    HEADER.AUTHORIZATION,
    HEADER.REQUEST_TENANT,
  ],
  [API_ENDPOINTS.AUTH_BACK_SESSION]: [HEADER.REQUEST_TENANT, HEADER.FLOW_ID],
  [API_ENDPOINTS.CURRENT_APPLICARION_WORKFLOW]: [
    HEADER.REQUEST_TENANT,
    HEADER.AUTHORIZATION,
  ],
  [API_ENDPOINTS.LOGIN]: [HEADER.REQUEST_TENANT],
  [API_ENDPOINTS.LOGIN_CALL_BACK]: [HEADER.REQUEST_TENANT],
  [API_ENDPOINTS.PARTNER_LOGIN]: [HEADER.REQUEST_TENANT],
  [API_ENDPOINTS.AUTH_CONNECT]: [
    HEADER.REQUEST_TENANT,
    HEADER.CONNECT_AUTH_API_KEY,
  ],
};

export const PATTERN_HEADERS = [
  {
    pattern: "/api/v1/master-service/tenants/",
    headers: [HEADER.REQUEST_TENANT],
  },
  {
    pattern: "/api/v1/workflow-service/requests/",
    headers: [HEADER.AUTHORIZATION, HEADER.REQUEST_TENANT],
  },
  {
    pattern: "/api/v1/finance-service/finance-applications/",
    headers: [HEADER.AUTHORIZATION, HEADER.REQUEST_TENANT],
  },
  {
    pattern: "/api/v1/finance-service/applications/",
    headers: [HEADER.AUTHORIZATION, HEADER.REQUEST_TENANT],
  },
];

export const PAYMENT_CARD_STATUS = {
  OVERDUE: 0,
  DUE_TODAY: 1,
  DUE_IN_NTH_DAYS: 2,
};

export const PAYMENT_STATUS = {
  PAID: "PAID",
  PENDING: "PENDING",
};

export const SEARCH_PARAMS = {
  DEVICE_ID: "deviceId",
  TENANT: "tenant",
  PRODUCT: "product",
  PARTNER_ID: "partnerId",
  PARTNER_TOKEN: "token",
  CHANNEL_ID: "channel",
  FLOW: "flow",
  NAFATH_SERVICE: "nafathServiceName",
  APP_URL: "appUrl",
  CUSTOME_PATH: "customPath",
};

export const EVENT_NAME = {
  APP_OPEN: "app_open",
  PAGE_VIEW: "page_view",
  ONBOARDING_COMPLETED: "complete_onboarding",
  SKIP_ONBOARDING: "skip_onboarding",
  LOGIN: "login",
  RESEND_OTP: "resend_otp",
  VERIFY_OTP: "verify_otp",
  MERCHANT_ONBOARDING_STATUS: "merchant_onboarding_status",
  SESSION_DURATION: "session_duration",
  ERROR_EVENT: "error_event",
  LOGOUT: "logout",
  JOURNEY_START: "journey_start",
  ORIGINAL_LANGUAGE: "original_language",
  LANGUAGE_CHANGE: "language_change",
  COMPLETE_FINANCE_JOURNEY: "compelete_finance_journey",
  COMPLETE_DISTRIBUTOR_JOURNEY: "complete_distributor_journey"
};

export const PAGE = {
  REQUIRED_DOCUMENT: "required document",
};

export const FILE_ACCEPT_MAP = {
  PDF: "application/pdf",
  XLS: "application/vnd.ms-excel",
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  DOC: "application/msword",
  DOCX: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  PNG: "image/png",
  JPG: "image/jpg",
  JPEG: "image/jpeg",
  WEBP: "image/webp",
  GIF: "image/gif",
  SVG: "image/svg+xml",
};

export const FILE_UPLOAD_STATUS = {
  UPLOADING: "UPLOADING",
  FAILED: "FAILED",
  NOT_STARTED: "NOT_STARTED",
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN_PROGRESS",
};

export const LINK_TEXT_ACTION = {
  NAVIGATE_TO: "NAVIGATE_TO",
  MAIL_TO: "MAIL_TO",
};

export const BACK_TO_LOGIN_PATHS = {
  BACK_PRE_LOGIN: "back_pre_login",
};

export const CONNECT_USER_DATA = {
  consent: {
    flowType: "TPP_MANAGED",
    permissionsList: [
      "ReadBalances",
      "ReadAccountsBasic",
      "ReadAccountsDetail",
      "ReadTransactionsBasic",
      "ReadTransactionsDetail",
      "ReadTransactionsCredits",
      "ReadTransactionsDebits",
    ],
  },
};

export const TARABUT_TPP_DETAILS = {
  tradingName: "Tarabut",
  legalName: "Tarabut",
  identifier: {
    type: "Other",
    value: "TPP CR Number",
  },
  purposeStatement: "CREDIT_ASSESSMENT",
};

export const FLEET_FINANCE_REQUIRED_DOCUMENTS = [
  {
    label: "vat_certificate",
    fileType: "pdf_png_jpg_max",
    toolTip: "vat_certificate",
    rightIcon: "how_it_work",
  },
  {
    label: "zakat_certificate",
    fileType: "pdf_png_jpg_max",
    toolTip: "zakat_certificate",
    rightIcon: "how_it_work",
  },
  {
    label: "gosi_certificate",
    fileType: "pdf_png_jpg_max",
    toolTip: "gosi_certificate",
    rightIcon: "how_it_work",
  },
  {
    label: "special_lisence",
    fileType: "pdf_png_jpg_max",
    toolTip: "special_lisence",
    rightIcon: "how_it_work",
  },
  {
    label: "financial_statement",
    fileType: "pdf_max",
    toolTip: "financial_statement",
    rightIcon: "how_it_work",
  },
  {
    label: "nationalization_certificate",
    fileType: "pdf_png_jpg_max",
    toolTip: "nationalization_certificate",
    rightIcon: "how_it_work",
  },
  {
    label: "owner_card_id",
    fileType: "pdf_png_jpg_max",
    toolTip: "owner_card_id",
    rightIcon: "how_it_work",
  },
  {
    label: "vat_summary_report",
    label_type: "annual_vat_report_files",
    fileType: "pdf_max",
    toolTip: "vat_summary_report",
    rightIcon: "how_it_work",
  },
  {
    label: "coc_certificate",
    fileType: "pdf_png_jpg_max",
    toolTip: "coc_certificate",
    rightIcon: "how_it_work",
  },
];

export const COUNTRY = {
  SAUDI_ARABIA: { CURRENCY_CODE: "SAR", COUNTRY: "Saudi Arabia" },
};

export const EMI_CALCULATION_TYPE = {
  STRAIGHT_LINE: "STRAIGHT_LINE", // Flat / Straight-line interest
  REDUCING_BALANCE: "REDUCING_BALANCE", // Standard EMI
};

export const LOAN_AMOUNT_TYPE = {
  MIN_FINANCING_AMOUNT: "MIN_FINANCING_AMOUNT", // Loan = min financing
  DIRECT_AMOUNT: "DIRECT_AMOUNT", // Loan from user input
  PERCENTAGE_BASED: "PERCENTAGE_BASED", // Loan = leasing - downpayment %
};

export const HOW_IT_WORKS_CARDS_LINK_ACTION = {
  SHOW_DOCUMENT_LIST: "show_document_list",
};

export const AUTH_FLOW = {
  INDIVIDUAL: "B2C",
  CORPORATE: "B2B",
  CUSTOM_JOURNEY: "CUSTOM_JOURNEY",
};
